var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowVectorCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C16.9543 48 8 39.0457 8 28C8 16.9543 16.9543 8 28 8C39.0457 8 48 16.9543 48 28C48 39.0457 39.0457 48 28 48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4698 34.9694C24.4001 35.039 24.3448 35.1218 24.3071 35.2128C24.2694 35.3039 24.25 35.4014 24.25 35.5C24.25 35.5985 24.2694 35.6961 24.3071 35.7872C24.3448 35.8782 24.4001 35.9609 24.4698 36.0306C24.5394 36.1003 24.6222 36.1556 24.7132 36.1933C24.8043 36.231 24.9018 36.2504 25.0004 36.2504C25.0989 36.2504 25.1965 36.231 25.2876 36.1933C25.3786 36.1556 25.4613 36.1003 25.531 36.0306L33.031 28.5306C33.1007 28.461 33.1561 28.3782 33.1938 28.2872C33.2315 28.1961 33.251 28.0986 33.251 28C33.251 27.9014 33.2315 27.8038 33.1938 27.7128C33.1561 27.6217 33.1007 27.539 33.031 27.4694L25.531 19.9694C25.3903 19.8286 25.1994 19.7496 25.0004 19.7496C24.8014 19.7496 24.6105 19.8286 24.4698 19.9694C24.329 20.1101 24.25 20.301 24.25 20.5C24.25 20.699 24.329 20.8899 24.4698 21.0306L31.4401 28L24.4698 34.9694Z",
    fill: "#4D2A90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowVectorCarousel);
export default __webpack_public_path__ + "static/media/right-arrow-vector-carousel.3cbce5d019c4f862f7ccec096f8d0c61.svg";
export { ForwardRef as ReactComponent };